/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "d1d9b60e6431f395d4c40d9e12b047a834738697";
